import { customer } from "./customer";
import { customerUpdate } from "./customerUpdate";
import { customerInfo } from "./customerInfo";
import { createCustomer } from "./createCustomer";
import { importCustomerData } from "./importCustomerData";
import { customerCpf } from "./customerCpf";
import { handleCustomerStatus } from "./handleCustomerStatus";

export const customerService = {
  customer,
  customerUpdate,
  customerInfo,
  createCustomer,
  importCustomerData,
  handleCustomerStatus,
  customerCpf,
};
